<template>
    <div
        class="toast"
        data-testid="toast"
        v-if="toast.message"
        @click="removeToast"
        :class="{
            'is-success': toast.type === 'SUCCESS',
            'is-error': toast.type === 'ERROR',
            'is-info': toast.type === 'INFO',
            'is-warn': toast.type === 'WARN',
        }"
    >
        <div class="indicator" />
        <div class="toast-message">
            <al-icon :icon="icon" />
            {{ toast.message }}
        </div>
    </div>
</template>
<script setup lang="ts">
import { state } from '@/utils/state';
import type { IToast } from '@agyletime/vue-3-common/src/typings/toast';
import {
    PropType, defineProps, ref
} from 'vue';

const props = defineProps({
    toast: {
        type: Object as PropType<IToast>,
        required: true
    },
    timeout: {
        type: Number,
        default: 5000
    }
});

function removeToast() {
    state.toasts = state.toasts.filter((t) => t.id !== props.toast.id);
}

const icon = ref<string>('');
switch (props.toast.type) {
    // TODO: Add icons for other states...
    case 'ERROR':
    case 'INFO':
    case 'WARN':
        icon.value = '';
        break;
    case 'SUCCESS':
    default:
        icon.value = 'check';
}

setTimeout(() => removeToast(), props.timeout);
</script>
<style lang="scss">
.toast {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: left;
    margin-top: 10px;

    /** Default success */
    background-color: var(--color-playvox-green-10);

    .toast-message {
        border-radius: 4px;
        padding: 8px 16px 8px 16px;
        min-width: 274px !important;
        width: auto;
        height: 36px;
        display: flex;
        align-items: center;

        /** Default success */
        background-color: var(--color-playvox-green-10);
        .al2-icon {
            color: #37b24d;
            font-size: 2.5em;
        }
    }

    .indicator {
        width: 6px;
        height: 52px;
        background-color: #37b24d;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    &.is-error {
        background-color: var(--color-red-salsa-10);

        .toast-message {
            background-color: var(--color-red-salsa-10);
            .al2-icon {
                color: #37b24d;
            }
        }

        .indicator {
            background-color: var(--color-red-salsa-60);
        }
    }

    &.is-warn {
        background-color: var(--color-maize-crayola--10);

        .toast-message {
            background-color: var(--color-maize-crayola--10);
            .al2-icon {
                color: #37b24d;
            }
        }

        .indicator {
            background-color: var(--color-maize-crayola-60);
        }
    }

    &.is-info {
        background-color: var(--color-ocean-blue-10);

        .toast-message {
            background-color: var(--color-ocean-blue-10);
            .al2-icon {
                color: #37b24d;
            }
        }

        .indicator {
            background-color: #37b24d;
        }
    }
}
</style>
